import React from "react";
import useWindowDimensions from "../hooks/getDimensions";
// import mainloader from "../Assets/img/mainloader.svg";

function Loader({ text }) {
  const { width } = useWindowDimensions();

  return (
    <>
     <div className="">
        <div
          className="position-fixed w-100 mainLoader"
          style={{
            zIndex: 999999999,
            height: "100%",
            marginLeft: 0,
            background: "rgba(0, 0, 0, 0.2)",
            backdropFilter: "blur(4.5px)",
            top: "0px",
            left: "0px",
          }}
        >
          <div className="h-100 d-flex align-items-center justify-content-center">
            <div className="d-flex flex-wrap align-items-center justify-content-center loader-parent">
              <img src="\assets\loader-bg.png" alt="img" className="img-fluid loader-bg" />
              <img
                width={90}
                src="https://res.cloudinary.com/drt6vurtt/image/upload/v1738224453/dop_mainnet/introdoploader_black_ij0ttv.gif"
                alt="loader"
              />
              {
                text && (
                  <h2 className="loader-text w-100 text-center">
                    {text}
                  </h2>
                )
              }
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default Loader;